/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_G1_71_49 as Componente_G1_71_49,
  rec_Componente_U1_85_49 as Componente_U1_85_49,
  rec_Componente_W1_87_49 as Componente_W1_87_49,
  rec_I1 as I1,
  rec_JSXRuntime as JSXRuntime,
  rec_R1 as R1,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function AnaliticaInspecciones(e) {
  let t = (0, ReactCompiler.c)(16),
    { constancia: n } = e,
    r;
  t[0] === n?.porPersona
    ? (r = t[1])
    : ((r = n?.porPersona ?? []), (t[0] = n?.porPersona), (t[1] = r));
  let i = r,
    a,
    o;
  if (t[2] !== n?.dondeSeDejan || t[3] !== i) {
    o = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      let e = n?.dondeSeDejan ?? [];
      if (!i.length) {
        o = null;
        break bb0;
      }
      let r;
      t[6] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((r = <h2 className={R1} children={`Cómo se llenan las actas`} />),
          (t[6] = r))
        : (r = t[6]);
      let s;
      t[7] === i
        ? (s = t[8])
        : ((s = i.map(Componente_G1_71_49)), (t[7] = i), (t[8] = s));
      let c;
      t[9] === s
        ? (c = t[10])
        : ((c = (
            <ul
              className={`divide-y divide-(--border) rounded-2xl border border-(--border) sm:hidden`}
              children={s}
            />
          )),
          (t[9] = s),
          (t[10] = c));
      let l;
      t[11] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((l = (
            <thead
              className={`sticky top-0 bg-(--panel) text-xs uppercase text-(--text)`}
              children={
                <tr
                  children={[
                    <th className={`p-3 font-medium`} children={`Persona`} />,
                    <th
                      className={`p-3 font-medium`}
                      children={`Terminadas`}
                    />,
                    <th
                      className={`p-3 font-medium`}
                      children={`Inconclusas`}
                    />,
                    <th
                      className={`p-3 font-medium`}
                      children={`Hasta dónde llega al dejarla`}
                    />,
                  ]}
                />
              }
            />
          )),
          (t[11] = l))
        : (l = t[11]);
      let u;
      t[12] === i
        ? (u = t[13])
        : ((u = i.map(Componente_W1_87_49)), (t[12] = i), (t[13] = u));
      let d;
      (t[14] === u
        ? (d = t[15])
        : ((d = (
            <div
              className={`hidden max-h-80 overflow-y-auto rounded-2xl border border-(--border) sm:block`}
              children={
                <table
                  className={`w-full text-left text-sm`}
                  children={[l, <tbody children={u} />]}
                />
              }
            />
          )),
          (t[14] = u),
          (t[15] = d)),
        (a = (
          <section
            className={`flex flex-col gap-3`}
            children={[
              r,
              c,
              d,
              e.length > 0 && (
                <div
                  className={`${I1} space-y-2`}
                  children={[
                    <p
                      className={`text-sm font-medium text-(--text-h)`}
                      children={`Dónde se dejan`}
                    />,
                    <ul
                      className={`space-y-1 text-sm`}
                      children={e.slice(0, 6).map(Componente_U1_85_49)}
                    />,
                  ]}
                />
              ),
            ]}
          />
        )));
    }
    ((t[2] = n?.dondeSeDejan), (t[3] = i), (t[4] = a), (t[5] = o));
  } else ((a = t[4]), (o = t[5]));
  return o === Symbol.for(`react.early_return_sentinel`) ? a : o;
}
